export const ssdkScriptIds = {
    injection: 'ssdk-injection',
    initialization: 'ssdk-initialization',
}
